import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import KeyIcon from "@mui/icons-material/Key";
import React, { useContext, useMemo } from "react";
import { useTextDomainContext } from "@/app/providers";

interface MenuItemRoleProps<TRow extends object = Record<string, unknown>> {
  row?: TRow;
  menuFor?: string;
  handleClose: () => void;
  menuClick: (_action: string, _row?: TRow) => void;
  showItems?: Record<string, boolean | undefined>;
}

export const MenuItemRole = <TRow extends object = Record<string, unknown>>(
  props: MenuItemRoleProps<TRow>,
): React.ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  //#region useMemo

  const menuFor = useMemo(() => {
    return props.menuFor ?? "";
  }, [props.menuFor]);

  //#endregion useMemo

  //#region Handlers

  const handleClose = () => {
    props.handleClose();
  };

  const handleEditAction = () => {
    props.menuClick(`${menuFor}-edit`, props.row);
    handleClose();
  };

  const handlePermissionsAction = () => {
    props.menuClick(`${menuFor}-permissions`, props.row);
    handleClose();
  };

  const handleDeleteAction = () => {
    props.menuClick(`${menuFor}-delete`, props.row);
    handleClose();
  };

  //#endregion Handlers

  return (
    <>
      {props?.showItems?.showEdit && (
        <MenuItem onClick={handleEditAction}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Edit")} />
        </MenuItem>
      )}

      {props?.showItems?.showPermissions && (
        <MenuItem onClick={handlePermissionsAction}>
          <ListItemIcon>
            <KeyIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Permissions")} />
        </MenuItem>
      )}

      {props?.showItems?.showDelete && (
        <MenuItem onClick={handleDeleteAction}>
          <ListItemIcon>
            <DeleteIcon color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={gettext("Delete")}
            slotProps={{
              primary: {
                color: "error",
              },
            }}
          />
        </MenuItem>
      )}
    </>
  );
};
